import React, { useMemo } from 'react';
import BaseModalComponent from '../BaseModal.component';
import ButtonComponent from '../../Button.component';
import { useTranslation } from 'react-i18next';
import { StyledFooterButtonContainer } from './ControlCreateEditModal';
import { useModalManager } from '../../../hooks/ModalManager.hook';
import styled from 'styled-components';

const StyledConfirmDuplicateModalBody = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
  padding: 10px;
  width: 300px;
`;

interface Props extends React.AllHTMLAttributes<HTMLDivElement> {
  message: string;
}

const ConfirmDuplicateModal = ({ message }: Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();
  const renderFooter = useMemo(
    () => (
      <StyledFooterButtonContainer>
        <ButtonComponent handleClick={closeModal}>{t('Close')}</ButtonComponent>
      </StyledFooterButtonContainer>
    ),
    [],
  );
  return (
    <BaseModalComponent footer={renderFooter} header={t('Duplicate')}>
      <StyledConfirmDuplicateModalBody>
        <div>{message}</div>
      </StyledConfirmDuplicateModalBody>
    </BaseModalComponent>
  );
};

export default ConfirmDuplicateModal;
